var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8779 5.47885C18.1424 4.994 17.9637 4.38657 17.4789 4.1221C16.994 3.85764 16.3866 4.0363 16.1221 4.52115L10.8488 14.1889L6.28632 8.38218C5.94511 7.94791 5.31645 7.87247 4.88218 8.21368C4.44791 8.5549 4.37247 9.18355 4.71368 9.61782L10.2137 16.6178C10.4214 16.8822 10.7481 17.0245 11.0832 16.9965C11.4183 16.9686 11.7169 16.774 11.8779 16.4789L17.8779 5.47885Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0C0.447715 0 0 0.447715 0 1V21C0 21.5523 0.447715 22 1 22H21C21.5523 22 22 21.5523 22 21V1C22 0.447715 21.5523 0 21 0H1ZM2 20V2H20V20H2Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.99f6c73f61d1df081e94acb49abb7ef5.svg";
export { ForwardRef as ReactComponent };